import styled from "styled-components"

export const NavbarWrapp = styled.section`
 /* Position and sizing of burger button */
.bm-burger-button {
  position: fixed;
  width: 22px;
  height: 18px;
  right: 24px;
  top: 23px;
}

/* Color/shape of burger icon bars */
.bm-burger-bars {
  background: #28342f;
}

/* Color/shape of burger icon bars on hover*/
.bm-burger-bars-hover {
  background: #5f7967;
}

/* Position and sizing of clickable cross button */
.bm-cross-button {
  height: 24px;
  width: 24px;
}

/* Color/shape of close button cross */
.bm-cross {
  background: #5f7967;
}

/*
Sidebar wrapper styles
Note: Beware of modifying this element as it can break the animations - you should not need to touch it in most cases
*/
.bm-menu-wrap {
  position: fixed;
  height: 100%;
  width: 240px !important;
}

/* General sidebar styles */
.bm-menu {
  background: #fbfaf7;
  padding: 2.5em 1.5em 0;
  border-left: 1px solid #e7e2d8;
  font-size: 1em;
}

/* Morph shape necessary with bubble or elastic */
.bm-morph-shape {
  fill: #373a47;
}

/* Wrapper for item list */
.bm-item-list {
  padding: 0.8em;

  a {
    color: #28342f;
    font-weight: 600;
  }

  li {
    margin-bottom: 14px;
  }
}

/* Individual item */
.bm-item {
  display: inline-block;
}

/* Styling of overlay */
.bm-overlay {
  background: rgba(31, 41, 51, 0.18);
}
`
